<template>
  <el-container class="login_container">
    <el-form
      ref="form"
      class="login_content"
      autocomplete="off"
      @keyup.enter="doLogin"
    >
      <!-- <el-image
        style="width: 300px;"
        :src="require('@/assets/images/logo.png')"
        class='logo'
        ></el-image> -->
      <div class="login_main_title">
        <p>{{ $config.pageName }}</p>
        <!-- <p>后台管理平台</p> -->
      </div>
      <div class="login_input_main">
        <div class="login_input_form">
          <div class="login_block_row">
            <el-input
              placeholder="请输入邮箱号"
              v-model="data.email"
              class="login_block_input"
              required="required"
              autocapitalize="off"
            >
              <template class="login_block_input" #prepend>邮箱号：</template>
            </el-input>
          </div>
          <div class="login_block_row">
            <el-input
              placeholder="请输入验证码"
              v-model="data.code"
              class="login_block_input"
              autocomplete="new-password"
              required="required"
              autocapitalize="off"
            >
              <template class="login_block_input" @click="sendCode" #prepend
                >验证码：</template
              >
              <template class="login_block_input" #suffix>
                <span @click="sendCode">{{
                  timer.text || "获取验证码"
                }}</span></template
              >
            </el-input>
          </div>
          <div class="login_block_row">
            <el-button type="primary" class="login_button" @click="doLogin"
              >登录</el-button
            >
          </div>
        </div>
      </div>
    </el-form>
  </el-container>
</template>

<script>
import { isEmail } from "@/utils/validate";
export default {
  name: "login",
  data() {
    return {
      data: {
        email: "",
        code: "",
      },
      codeLoading: false,
      loading: false,
      timer: {
        time: null,
        maxCount: 60000,
        startTime: 0,
        text: "",
      },
    };
  },
  created() {
    let data = this.$tools.getLocalCookie("loginData") || null;
    if (data) this.data = data;
    this.timer.startTime = this.$tools.getStorage("downStartTime");
    this.checkTime();
  },
  methods: {
    sendCode() {
      if (this.codeLoading || this.timer.time) return;
      if (!this.data.email) {
        this.$tips.error({ text: "请输入邮箱号" });
        return false;
      }
      if (!isEmail(this.data.email)) {
        this.$tips.error({ text: "邮箱号不正确" });
        return false;
      }
      this.codeLoading = true;
      this.$axios
        .get(`${this.$urls.user.code}?email=${this.data.email}`)
        .then(() => {
          setTimeout(() => {
            this.codeLoading = false;
          }, 1000);
          this.timer.startTime = Date.now();
          this.checkTime();
          this.$tips.success({ text: "发送成功" });
        })
        .catch(() => {
          setTimeout(() => {
            this.codeLoading = false;
          }, 1000);
        });
    },
    checkTime() {
      if (this.timer.time) {
        clearTimeout(this.timer.time);
        this.timer.time = null;
      }
      let curTime = Date.now();
      if (this.timer.startTime + this.timer.maxCount > curTime) {
        this.timer.text = `${Math.floor(
          (this.timer.maxCount - (curTime - this.timer.startTime)) / 1000
        )}s`;
        this.$tools.setStorage("downStartTime", this.timer.startTime);
        this.timer.time = setTimeout(() => {
          this.checkTime();
        }, 1000);
      } else {
        this.timer.startTime = 0;
        this.timer.text = "";
        this.codeLoading = false;
        this.$tools.setStorage("downStartTime", this.timer.startTime);
      }
    },
    verityData() {
      if (!this.data.email) {
        this.$tips.error({ text: "请输入邮箱" });
        return false;
      }
      if (!isEmail(this.data.email)) {
        this.$tips.error({ text: "邮箱不正确" });
        return false;
      }
      if (this.data.code == "") {
        this.$tips.error({ text: "请输入验证码" });
        return false;
      }
      return true;
    },
    setAccountId(account_id) {
      let loginData = this.$tools.getLocalCookie("loginData");
      loginData.account_id = account_id;
      this.$tools.setLocalCookie("loginData", loginData);
    },
    doLogin() {
      if (!this.verityData() || this.loading) return;
      this.loading = true;
      this.$tools.setLocalCookie("loginData", this.data);
      // this.$axios.post(this.$urls.user.login,this.$tools.getFormData(this.data)).then((res)=>{
      this.$axios
        .post(this.$urls.user.login, this.data)
        .then((res) => {
          this.setAccountId(res.data.account_id);
          this.$tools.setStorage("userInfo", res.data);
          this.$store.dispatch("setItem", { userInfo: res.data });
          setTimeout(() => {
            this.loading = false;
          }, 1000);
          let toPath = this.$tools.getStorage("toPath") || {};
          let path = toPath.path;
          if(path){
            let query = {...toPath.query};
            this.$tools.setStorage("toPath", {});
            this.$router.push({
              path: path,
              query:query
            });
          }else{
            this.$router.push({
              path: "/",
            });
          }
        })
        .catch((err) => {
          console.error(err)
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
.login_container {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #222;
}
input:-webkit-autofill {
  background-color: #333 !important;
}
.login_content {
  height: auto;
}
.login_input_main {
  width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.login_input_form {
  width:70vw;
}
.login_block_row {
  height: 13vw;
}
.login_block_input > :nth-child(n) {
  background: #333 !important;
  border: 0;
  color: #fff;
  padding-right: 0 !important;
}
.login_button {
  width: 100%;
}
.login_block_row .el-input__suffix {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 16vw;
}

.login_block_row .el-input__suffix:hover {
  cursor: pointer;
}
.login_block_row .el-input{
  font-size: 3vw;
}
.login_main_title {
  font-size: 45px;
  line-height: 60px;
  color: #fff;
  font-weight: 700;
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 60px 0;
  text-align: center;
}
</style>
